import React from "react";
import { Link } from "react-router-dom";

export default function MerchantForbiddenPage() {
  return (
    <div className="merchant-card merchant-empty-state">
      <div className="merchant-page-title">Access restricted</div>
      <div className="merchant-page-subtitle">
        Your merchant role does not currently have permission to open this page.
      </div>
      <Link className="merchant-button merchant-button-primary" to="/">
        Go to allowed home
      </Link>
    </div>
  );
}
